import React, { useState, useEffect } from 'react';
import styles from './ColorSelector.module.scss';
import { Popover, Button } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CirclePicker } from 'react-color';

const ColorSelector = (props) => {
	const [anchorEl, setAnchorEl] = useState();
	const { color, setColor } = props;

	const handleOpenColorPicker = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseColorPicker = () => {
		setAnchorEl(null);
	};

	const handleChangeColor = (color) => {
		setColor(color.hex);
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		<div className={styles.color_selector}>
			<Button
				fullWidth
				variant='outlined'
				endIcon={<ArrowDropDownIcon />}
				className={styles.color_dropdown}
				onClick={handleOpenColorPicker}
			>
				{color ? (
					<div
						className={styles.color_block}
						style={{ backgroundColor: color }}
					></div>
				) : (
					<p>color of role preset</p>
				)}
			</Button>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleCloseColorPicker}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<div className={styles.color_picker}>
					<CirclePicker
						circleSize={44}
						circleSpacing={25}
						width='350px'
						colors={[
							'#FBBC05',
							'#FF9E00',
							'#FF5C00',
							'#CCDE5E',
							'#4C881C',
							'#77C6E8',
							'#A970E2',
							'#FFA4DA',
							'#16A78D',
							'#C32929',
						]}
						onChange={handleChangeColor}
					/>
				</div>
			</Popover>
		</div>
	);
};

export default ColorSelector;
